function isNonNegativeNumber(number) {
	return number > 0;
}

module.exports = isNonNegativeNumber;